import React from "react";

const generalInsuranceAccountsSyllabus = [
    {
        chapter: 1,
        title: "Basics of Accounting",
        subTopics: [
            "Meaning and Scope of Financial Accounting",
            "Accounting – Concepts, Principles and Conventions",
            "Accounting Standards – AS & Ind AS",
            "Accounting Policies",
        ],
        hours: 4,
    },
    {
        chapter: 2,
        title: "Finalisation of Accounts",
        subTopics: [
            "Accounting Process",
            "Accounting Methods",
            "Accounting Procedures",
            "Accounting Controls",
            "Depreciation",
            "BRS – Bank Reconciliation Statements",
            "Company Accounts (As per Companies Act 2013)",
        ],
        hours: 4,
    },
    {
        chapter: 3,
        title: "Non-Life Insurance Business Accounting",
        subTopics: [
            "General Insurance Accounting Process and Techniques",
            "Insurance Accounting Regulations",
            "Preparation & Presentation of Financial Statements",
            "Re-Insurance Accounting",
        ],
        hours: 4,
    },
    {
        chapter: 4,
        title: "Accounting Methods and Process – Special Accounting Transactions",
        subTopics: [
            "Investment Regulations",
            "IRDAI (Investment) Regulations, 2016",
        ],
        hours: 3,
    },
    {
        chapter: 5,
        title: "Annual Reports, Audits & International Financial Reporting Standards",
        subTopics: [
            "Annual Reports (Based on Companies Act 2013)",
            "Statutory Audit in General Insurance Business",
            "Internal Audit in General Insurance Business",
        ],
        hours: 2,
    },
    {
        chapter: 6,
        title: "Taxation",
        subTopics: [
            "Goods and Services Tax (GST)",
        ],
        hours: 1,
    },
];


export const AccountsPreparationsAndInvestmentRegulationTable = () => {
    const totalHours = generalInsuranceAccountsSyllabus.reduce((sum, item) => sum + item.hours, 0);

    return (
        <div className="container my-3 px-0"
            style={{
                maxHeight: 'fit-content'
            }}
        >
            <h5 className="text-center">IC-46- GENERAL INSURANCE ACCOUNTS PREPARATION & REGULATION OF INVESTMENT
            </h5>
            <div className="table-responsive"
                style={{ height: '70vh' }}
            >
                <table className="table table-bordered table-striped align-middle">
                    <thead className="table-success text-center">
                        <tr>
                            <th className="bgblue">Chapter</th>
                            <th className="bgblue">Title</th>
                            <th className="bgblue">Sub-Topics</th>
                            <th className="bgblue">Training Hours</th>
                        </tr>
                    </thead>
                    <tbody>
                        {generalInsuranceAccountsSyllabus.map((item, index) => (
                            <tr key={index}>
                                <td className="text-center fw-bold">{item.chapter}</td>
                                <td>{item.title}</td>
                                <td>
                                    <ul className="mb-0 ps-3" style={{ listStylePosition: "inside" }}>
                                        {item.subTopics.map((topic, i) => (
                                            <li key={i}>{topic}</li>
                                        ))}
                                    </ul>
                                </td>
                                <td className="text-center fw-semibold">{item.hours}</td>
                            </tr>
                        ))}
                        <tr className="table-secondary fw-bold">
                            <td colSpan={3} className="text-end">Total Training Hours =</td>
                            <td className="text-center">{totalHours}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
